import { render } from "./PermissionsTable.vue?vue&type=template&id=3aeabbbd"
import script from "./PermissionsTable.vue?vue&type=script&lang=js"
export * from "./PermissionsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__